<video
class="w-full h-full object-cover overflow-hidden z-10"
[ngClass]="aspectClasses"
#videoElement
crossorigin
playsinline
autoplay
loop></video>
